import React, {
  ReactNode,
  FC,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";

import { useOnClickOutside } from "../../../hooks/use-onclick-outside";
import { Icon } from "../index";

import styles from "./index.module.css";

type ModalProps = {
  children: ReactNode;
  isShow: boolean;
  onShow?: (b: boolean) => void;
  width?: number;
};

const Modal: FC<ModalProps> = (props) => {
  const { isShow, children, onShow, width } = props;
  const [open, setOpen] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    setOpen(isShow);
  }, [isShow]);

  const escFunction = useCallback(
    (event) => {
      if (event.key === "Escape") {
        onShow?.(false);
      }
    },
    [onShow]
  );

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  function handleClose() {
    setOpen(false);
    onShow?.(false);
  }

  useOnClickOutside(modalRef, () => handleClose());

  if (!open) return <></>;

  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} />
      <div
        ref={modalRef}
        className={styles.modalContainer}
        style={width ? { width: "100%", maxWidth: `${width}px` } : {}}
      >
        <div className={styles.modalHeader}>
          <div className={styles.closeButton} onClick={handleClose}>
            <span className={styles.escText}>esc</span>
            <Icon name="X" size={20} />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
